import React from "react";
import { connect } from "react-redux";
import { toggleModal, storeError } from "../store/common";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { getTranslate } from "react-localize-redux";
import { createMarkup } from "../utils/product.util";

const ErrorModal = ({ error, getModalStatus, toggleModal, translate }) => (
  <Modal
    size="lg"
    isOpen={getModalStatus && error}
    toggle={() => toggleModal("error_modal", false)}
    className="error__modal"
    centered={true}
  >
    <ModalHeader>Error</ModalHeader>
    <ModalBody>
      {/* <p>{error && error.message ? error.message : error}</p> */}
      <p
        dangerouslySetInnerHTML={createMarkup(
          error && error.message ? error.message : error
        )}
      />
    </ModalBody>
    <ModalFooter>
      <Button
        color="secondary"
        onClick={() => toggleModal("error_modal", false)}
      >
        Ok
      </Button>
    </ModalFooter>
  </Modal>
);

ErrorModal.propTypes = {};

const mapStateToProps = ({ common, locale }) => ({
  translate: getTranslate(locale),
  getModalStatus: common.modals.error_modal ? common.modals.error_modal : null,
  error: common.error
});

const mapDispatchToProps = dispatch => ({
  toggleModal: (modalName, action) => dispatch(toggleModal(modalName, action)),
  storeError: () => dispatch(storeError(null))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorModal);



// WEBPACK FOOTER //
// ./src/containers/ErrorModal.js